<template>
<v-app>
    <Menu />
    <v-content>
        <v-container fluid>
            <router-view></router-view>
        </v-container>
    </v-content>
        <!-- แจ้งเตือนเครื่องปริ้นไม่ออก -->
        <v-dialog v-model="open_notification_call_staff" persistent max-width="600px">
      <v-sheet
        v-if="loading_notification_call_staff"
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
      
      <v-card v-else>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6" style="font-family: Kanit, sans-serif !important;">แจ้งเตือน ลูกค้าเรียกพนักงาน</span>
          <v-icon
            @click="closeNotificationCallStaff"
            class="cursor-pointer"
          >mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="text-center">
          <!-- <div class="clock_notification_image mb-2">
            <img src="@/assets/printer.png">
          </div> -->
          <div class="mb-4">
            <div class="list_table_poslist">
                <img src="@/assets/table-success.png">
                <div class="title_number_table_poslist d-flex justify-center align-center flex-column">
                  <!-- โต๊ะ {{ detail.name}} -->
                    <div style="font-size: 20px;">โต๊ะ {{ notification_table_name}}</div>
                    
                </div>
              </div>
          </div>
          
          <div class="mb-4">
            <span class="text-subtitle-1" style="font-family: Kanit, sans-serif !important; font-size: 1.1rem !important;">
              โต๊ะที่: <strong>{{ notification_table_name }}</strong>
            </span>
          </div>
          <!-- <div class="mb-4">
            <span class="text-subtitle-1" style="font-family: Kanit, sans-serif !important; font-size: 1.1rem !important;">
              เวลาที่ถูกเรียก: <strong>{{ notification_table_time }}</strong>
            </span>
          </div> -->
          <h2 class="error--text mb-6">
            เวลาที่ถูกเรียก: <strong>{{ notification_table_time }}</strong>
          </h2>
          <v-btn
            class="grad-primary-bg white--text"
            height="50"
            width="40%"
            @click="closeNotificationCallStaff(notification_table_id)"
          >
            ปิดหน้าต่าง
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- แจ้งเตือนเครื่องปริ้นไม่ออก -->
    <v-dialog v-model="open_notification_timeout_printer" persistent max-width="600px">
        <v-sheet
            v-if="loading_notification_timeout_printer"
            :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
            class="pa-3"
        >
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
        
        <v-card v-else>
            <v-card-title class="d-flex justify-space-between align-center">
            <span class="text-h6" style="font-family: Kanit, sans-serif !important;">แจ้งเตือนเครื่องปริ้นไม่ออก</span>
            <v-icon
                @click="closeNotificationTimeoutPrinter"
                class="cursor-pointer"
            >mdi-close</v-icon>
            </v-card-title>

            <v-card-text class="text-center">
            <div class="clock_notification_image mb-2">
                <img src="@/assets/printer.png">
            </div>
            <div class="mb-4">
                <span class="text-subtitle-1" style="font-family: Kanit, sans-serif !important; font-size: 1.1rem !important;">
                เครื่องปริ้น: <strong>{{ notification_printer_name }}</strong>
                </span>
            </div>
            <div class="mb-4">
                <span class="text-subtitle-1" style="font-family: Kanit, sans-serif !important; font-size: 1.1rem !important;">
                เวลาเครื่องปริ้นไม่ออก: <strong>{{ notification_printer_time }}</strong>
                </span>
            </div>
            <h2 class="error--text mb-6">
                ** กรุณาปิด - เปิดเครื่องปริ้นใหม่ **
            </h2>
            <v-btn
                class="grad-primary-bg white--text"
                height="50"
                width="40%"
                @click="closeNotificationTimeoutPrinter"
            >
                ปิดหน้าต่าง
            </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</v-app>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import userprofile from '@/api/userprofile/userprofile.js'
import createfoodbom from '@/api/createfoodbom/createfoodbom.js'
import Menu from '@/components/menuadmin/Menu.vue'
export default {
    name: 'pageAll',
    components: {
        Menu,
    },
    data() {
        return {
            notification_table_id: null,
            notification_table_name: null,
            notification_table_type: null,
            notification_table_time: null,
            open_notification_call_staff: false,
            loading_notification_call_staff: false,
            open_notification_timeout_printer: false,
            loading_notification_timeout_printer: false,
            notification_printer_name: null,
            notification_printer_type: null,
            notification_printer_time: null,
        }
    },
    created() {
        // this.checkUnprocessedOrders(); // เรียกเช็คครั้งแรก
        this.checkUnprocessedCallStaff(); // เรียกเช็คครั้งแรก
        setInterval(() => {
            this.checkUnprocessedOrders();
            this.checkUnprocessedCallStaff();
        }, 60000); // 2 นาที
    },
    methods: {
        playTextToSpeech(text) {
            if ('speechSynthesis' in window) {
                const utterance = new SpeechSynthesisUtterance(text);
                utterance.lang = 'th-TH'; // ใช้ภาษาไทย
                utterance.rate = 1; // ความเร็วของเสียง (1 คือค่าปกติ)
                utterance.pitch = 1; // ระดับเสียง (1 คือค่าปกติ)
                window.speechSynthesis.speak(utterance);
                // console.log('11');
                
            } else {
                console.error("Web Speech API is not supported in this browser.");
            }
        },
        async checkUnprocessedOrders() {
            try {
                const response = await HTTP.get('check_unprocessed_orders', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                });
           
                if (response.data.successful && response.data.data.length > 0) {
           
                    this.notification_printer_name = response.data.data[0].printer_name;
                    this.notification_printer_time = this.formatDateTime(response.data.data[0].no_print_time);
                    this.loading_notification_timeout_printer = false;
                    this.open_notification_timeout_printer = true;
                    // // เล่นเสียงพูด
                    const message = `printer ${this.notification_printer_name} มีปัญหา กรุณาปิดเปิด Printer ค่ะ`;
                    this.playTextToSpeech(message);
                }
        
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$store.commit('logOutSuccess');
                    this.$router.push('/login');
                }
            }
        },
        async checkUnprocessedCallStaff() {
            try {
                const response = await HTTP.get('/updateCallEmp' , {
                    params: { id: null },
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                });
                
                if (response.data.successful && response.data.data.length > 0) {

                    this.notification_table_id = response.data.data[0].tables_id;
                    this.notification_table_name = response.data.data[0].tables_name;
                    this.notification_table_time = this.formatDateTime(response.data.data[0].staff_time);

                    this.loading_notification_call_staff = false;
                    this.open_notification_call_staff = true;

                    // // เล่นเสียงพูด
                    const message = `โต๊ะ ${this.notification_table_name} เรียกพนักงานค่ะ`;
                    this.playTextToSpeech(message);
                }
        
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$store.commit('logOutSuccess');
                    this.$router.push('/login');
                }
            }
        },
        async UpdateStatusCallStaff(id) {
            try {
                const response = await HTTP.get('/updateCallEmp/'+id , {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                });

                if (response.data.successful && response.data.data.length > 0) {
                console.log('success');
                }
        
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$store.commit('logOutSuccess');
                    this.$router.push('/login');
                }
            }
        },

        formatDateTime(dateTime) {
            const date = new Date(dateTime);
            const formattedTime = date.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            const formattedDate = date.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: 'numeric' });
            return `${formattedTime} ${formattedDate}`;
        },
        async userProfile() {
            userprofile.userProfile().then((response) => {
                if (response.data.successful === true) {
                    this.$store.commit('userProfileSuccess', response.data.userProfile)

                    //เฉพาะสิทธ์ Admin ที่เข้าได้
                    if (this.$route.path == '/' || this.$route.path == '/dashboard' || this.$route.path == '/lotdetailinedit' || this.$route.path == '/lotdetailoutedit') {
                        if (response.data.userProfile.permission_type == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Team ทีมงาน
                    if (this.$route.path == '/myteam' || this.$route.path == '/editteam') {
                        if (response.data.userProfile.per_my_team == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/addteam') {
                        if (response.data.userProfile.per_add_team == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Sales ยอดขาย
                    if (this.$route.path == '/dailycostreport') {
                        if (response.data.userProfile.per_cost_sell == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salestatistic') {
                        if (response.data.userProfile.per_statistic_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salereport') {
                        if (response.data.userProfile.per_see_all_report == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Stock คลัง
                    if (this.$route.path == '/stockreport') {
                        if (response.data.userProfile.per_inventory_report == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/materialnow') {
                        if (response.data.userProfile.per_raw_material == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/addlotinpo' || this.$route.path == '/addlotin') {
                        if (response.data.userProfile.per_materials_add_warehouse == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/alllot' || this.$route.path == '/lotdetailin' || this.$route.path == '/lotdetailinedit' || this.$route.path == '/lotdetailout' || this.$route.path == '/lotdetailoutedit') {
                        if (response.data.userProfile.per_warehouse_in_out == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/purchaseorder' || this.$route.path == '/purchaseordernew' || this.$route.path == '/purchaseordernewdetail' || this.$route.name == 'purchaseOrderDetail') {
                        if (response.data.userProfile.per_material_purchase_order == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/stocktype' || this.$route.path == '/stocksource' || this.$route.path == '/stockunit' || this.$route.path == '/stockzone') {
                        if (response.data.userProfile.per_setup_stock == 0) {
                            this.$router.push('/restaurant')
                        }
                    }

                    // Restaurant ร้านอาหาร
                    if (this.$route.path == '/addfood' || this.$route.path == '/addtopping') {
                        if (response.data.userProfile.per_add_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/fooddetail' || this.$route.path == '/toppingdetail') {
                        if (response.data.userProfile.per_edit_food == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/buffetmanage') {
                        if (response.data.userProfile.per_setup_buffe == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/advertisebuffet' || this.$route.path == '/advertisesingledishmeal' || this.$route.path == '/advertisetakeout') {
                        if (response.data.userProfile.per_setup_advertise == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/billretrospectall') {
                        if (response.data.userProfile.per_invoice_retrospect == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/salereportday') {
                        if (response.data.userProfile.per_report_retrospect == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/closeretrospectall' || this.$route.path == '/closeretrospectdetail') {
                        if (response.data.userProfile.per_see_close == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    if (this.$route.path == '/settingrestaurant') {
                        if (response.data.userProfile.per_setting_store == 0) {
                            this.$router.push('/restaurant')
                        }
                    }
                    createfoodbom.createFoodBom()
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async closeNotificationTimeoutPrinter(){
            this.open_notification_timeout_printer = false
            this.notification_printer_name = null
            this.notification_printer_type = null
            this.notification_printer_time = null
        },
        async closeNotificationCallStaff(id){
            this.UpdateStatusCallStaff(id)
            this.open_notification_call_staff = false
            this.notification_table_id = null
            this.notification_table_name = null
            this.notification_table_time = null
            // this.notification_printer_time = null
        },
    },
    beforeMount() {
        this.userProfile()
    },
    watch: {
        $route() {
            this.userProfile()
        },
    }
}
</script>
